module.exports = __webpack_public_path__ + "img/setup-test-step-1-desktop.fa8fde53.png";